<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-credit-card"></i>
      <h3>Detalle de Cuenta</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-credit-card"></i>
      <p>No hay información de cuenta disponible</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Información Principal de la Cuenta -->
      <div class="section">
        <h4 class="section-title">Información Principal</h4>
        <div class="data-grid">
          <div class="data-item featured" *ngIf="data?.accountNumber">
            <label>Número de Cuenta:</label>
            <span class="value account-number">{{ data?.accountNumber }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.contractType">
            <label>Tipo de Contrato:</label>
            <span [class]="data?.contractType ? 'value' : 'placeholder'">
              {{ contractTypeDisplay }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.accountType">
            <label>Tipo de Cuenta:</label>
            <span [class]="data?.accountType ? 'value' : 'placeholder'">
              {{ data?.accountType || 'No especificado' }}
            </span>
          </div>

          <div class="data-item status-item" [class.empty]="!data?.accountStatus">
            <label>Estado de la Cuenta:</label>
            <span [class]="data?.accountStatus ? 'value status-badge' : 'placeholder'" 
                  [attr.data-status]="data?.accountStatus">
              {{ accountStatusDisplay }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información Financiera -->
      <div class="section" *ngIf="data?.currentBalance !== undefined || data?.creditLimit !== undefined">
        <h4 class="section-title">Información Financiera</h4>
        <div class="financial-overview">
          <div class="financial-cards">
            <div class="financial-card balance" *ngIf="data?.currentBalance !== undefined">
              <div class="financial-header">
                <i class="pi pi-wallet"></i>
                <span class="label">Saldo Actual</span>
              </div>
              <div class="amount">{{ formatCurrency(data?.currentBalance) }}</div>
            </div>

            <div class="financial-card limit" *ngIf="data?.creditLimit !== undefined">
              <div class="financial-header">
                <i class="pi pi-chart-line"></i>
                <span class="label">Límite de Crédito</span>
              </div>
              <div class="amount">{{ formatCurrency(data?.creditLimit) }}</div>
            </div>

            <div class="financial-card utilization" 
                 *ngIf="data?.currentBalance !== undefined && data?.creditLimit !== undefined"
                 [class]="getUtilizationClass()">
              <div class="financial-header">
                <i class="pi pi-percentage"></i>
                <span class="label">Utilización</span>
              </div>
              <div class="percentage-display">{{ getCreditUtilization() }}%</div>
              <div class="utilization-bar">
                <div class="utilization-fill" [style.width.%]="getCreditUtilization()"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fechas Importantes -->
      <div class="section">
        <h4 class="section-title">Fechas Importantes</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.openingDate">
            <label>Fecha de Apertura:</label>
            <span [class]="data?.openingDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.openingDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.lastPaymentDate">
            <label>Último Pago:</label>
            <span [class]="data?.lastPaymentDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.lastPaymentDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.closingDate">
            <label>Fecha de Cierre:</label>
            <span [class]="data?.closingDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.closingDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.statementDate">
            <label>Fecha de Corte:</label>
            <span [class]="data?.statementDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.statementDate) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información CAN (Centro de Atención Nacional) -->
      <div class="section">
        <h4 class="section-title">Información CAN</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.canStatus">
            <label>Estatus CAN:</label>
            <span [class]="data?.canStatus ? 'value' : 'placeholder'">
              {{ data?.canStatus || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.canOpeningDate">
            <label>Fecha Apertura CAN:</label>
            <span [class]="data?.canOpeningDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.canOpeningDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.canCancellationDate">
            <label>Fecha Cancelación CAN:</label>
            <span [class]="data?.canCancellationDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.canCancellationDate) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información Adicional -->
      <div class="section">
        <h4 class="section-title">Información Adicional</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.pastDueBalance" *ngIf="data?.pastDueBalance !== undefined">
            <label>Saldo Vencido:</label>
            <span [class]="data?.pastDueBalance ? 'value warning' : 'placeholder'">
              {{ formatCurrency(data?.pastDueBalance) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.daysPastDue" *ngIf="data?.daysPastDue !== undefined">
            <label>Días de Vencimiento:</label>
            <span [class]="data?.daysPastDue ? 'value warning' : 'placeholder'">
              {{ data?.daysPastDue || 0 }} días
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.paymentsHistory" *ngIf="data?.paymentsHistory">
            <label>Historial de Pagos:</label>
            <span class="value payment-history">{{ data?.paymentsHistory }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
